import { ControlledTextInput } from '@Components/index';
import { ExtendedUseFormReturn } from '@Hooks/index';
import { OnboardingFormFields } from '@Types/index';
import { FormProvider } from 'react-hook-form';
import type { OtherFormSchema } from './OtherFormSchema';

interface OtherFormProps {
  formMethods: ExtendedUseFormReturn<OtherFormSchema>;
}
export const OtherForm = ({ formMethods }: OtherFormProps) => {
  return (
    <FormProvider {...formMethods}>
      <ControlledTextInput
        control={formMethods.control}
        name={OnboardingFormFields.ACCOUNT_OPENING_REASON}
        id='accountOpeningReason'
        max={150}
      />
    </FormProvider>
  );
};
